import type { CustomFieldValue } from '@vy/custom-fields-types';

export function extractUniqueCustomFieldNames(
  customFieldValuesArrays: (CustomFieldValue[] | undefined)[],
): string[] {
  const fieldNamesSet = new Set<string>();

  for (const customFieldValues of customFieldValuesArrays) {
    if (!customFieldValues) {
      continue;
    }

    for (const customFieldValue of customFieldValues) {
      if (customFieldValue.fieldName) {
        fieldNamesSet.add(customFieldValue.fieldName);
      }
    }
  }

  return Array.from(fieldNamesSet).sort();
}
